import { render, staticRenderFns } from "./settings-sync-pane.vue?vue&type=template&id=50deb672&scoped=true"
import script from "./settings-sync-pane.vue?vue&type=script&lang=js"
export * from "./settings-sync-pane.vue?vue&type=script&lang=js"
import style0 from "./settings-sync-pane.vue?vue&type=style&index=0&id=50deb672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50deb672",
  null
  
)

export default component.exports